<div class="contact">
  <div class="contact__inner row pad">
    <div class="contact__text text-muted">CONTACT</div>
    <h1 class="contact__title">
      Let’s build unforgettable experiences together
    </h1>
    <div class="contact__subtitle">
      We’d love to hear from you. Whether you’re a partner, press, or fan —
      let’s connect.
    </div>
    <div class="contact__links">
      <a
        href="https://mari.careers.hibob.com/"
        class="contact__link"
        target="_blank"
        ><div class="text-muted">&nbsp;</div>
        <span>Careers</span></a
      >
      <a
        href="mailto:contactus@marigrp.com"
        class="contact__link"
        target="_blank"
        ><div class="text-muted">General inquiries</div>
        <span>contactus@marigrp.com</span></a
      >
      <a href="mailto:press@marigrp.com" class="contact__link" target="_blank"
        ><div class="text-muted">Press Inquiries</div>
        <span>press@marigrp.com</span></a
      >
    </div>
  </div>
</div>
